import { DexDispatcherFormEnumType, DexFormsResponse, DexFormView } from '@mark43/cad-api';
import { Panel } from '../../panels/panel';
import { PanelTitle } from '../../panels/panel-title';
import { WorkspacePanel } from '../../panels/workspace-panel';
import { DexArticleForm } from './dex-article-form';
import { DexBoatForm } from './dex-boat-form';
import { DexFirearmForm } from './dex-firearm-form';
import { DexLojackForm } from './dex-lojack-form';
import { DexPersonForm } from './dex-person-form';
import { DexVehicleForm } from './dex-vehicle-form';
import { useDexFormsQuery } from './use-dex-forms-query';
import { useDexFormView } from './use-dex-form-view';
import { SelectedOriAliasProvider } from './use-selected-ori-alias';
import { EventWorkspacePanelDexFormPrefill } from '../../panels/workspace-panel-types';
import { DexImageForm } from './dex-image-form';
import { DexNextFormPanel } from './dex-next-form-panel';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { observer } from 'mobx-react-lite';

export function DexFormPanelBody({
    dexFormsResponse,
    dexForm,
    dexFormEventPanelPrefillValues,
}: {
    dexFormsResponse: DexFormsResponse;
    dexForm: DexDispatcherFormEnumType;
    dexFormEventPanelPrefillValues?: EventWorkspacePanelDexFormPrefill;
}): React.ReactElement {
    const {
        articleFormBootstrapView,
        boatFormBootstrapView,
        firearmFormBootstrapView,
        firearmConcealedWeaponsFormBootstrapView,
        firearmsOwnersIdFormBootstrapView,
        lojackFormBootstrapView,
        personFormBootstrapView,
        personProbationFormBootstrapView,
        personSexOffenderFormBootstrapView,
        personWarrantDetailFormBootstrapView,
        vehicleFormBootstrapView,
        vehicleRegistrationByPlateFormBootstrapView,
        vehicleRegistrationByVinFormBootstrapView,
        vehicleRegistrationByNameFormBootstrapView,
        vehicleRegistrationByOtherFormBootstrapView,
        vehicleRegistrationByRecentQueryFilesFormBoostrapView,
        vehicleByNameFormBootstrapView,
        imageFormBootstrapView,
        criminalHistoryIndexFormBootstrapView,
        criminalHistoryRecordRequestFormBootstrapView,
        criminalHistoryIdentityQueryFormBootstrapView,
        criminalHistoryFullRecordFormBootstrapView,
        vehicleStolenFormBootstrapView,
        crimsFormBootstrapView,
        canadianWantedPersonFormBootstrapView,
        canadianDriverLicenseFormBootstrapView,
        canadianVehicleRegistrationFormBootstrapView,
    } = dexFormsResponse;
    switch (dexForm) {
        case 'ARTICLE_MASTER_QUERY':
            if (!articleFormBootstrapView) {
                return <></>;
            }
            return (
                <DexArticleForm
                    formBootstrapView={articleFormBootstrapView}
                    dexFormEventPanelPrefillValues={dexFormEventPanelPrefillValues}
                />
            );
        case 'BOAT_MASTER_QUERY':
            if (!boatFormBootstrapView) {
                return <></>;
            }
            return <DexBoatForm formBootstrapView={boatFormBootstrapView} />;
        case 'FIREARM_MASTER_QUERY':
            if (!firearmFormBootstrapView) {
                return <></>;
            }
            return (
                <DexFirearmForm
                    formBootstrapView={firearmFormBootstrapView}
                    dexFormEventPanelPrefillValues={dexFormEventPanelPrefillValues}
                />
            );
        case 'FIREARM_CONCEALED_WEAPONS_QUERY':
            if (!firearmConcealedWeaponsFormBootstrapView) {
                return <></>;
            }
            return <DexFirearmForm formBootstrapView={firearmConcealedWeaponsFormBootstrapView} />;
        case 'FIREARM_OWNERS_ID_QUERY':
            if (!firearmsOwnersIdFormBootstrapView) {
                return <></>;
            }
            return <DexFirearmForm formBootstrapView={firearmsOwnersIdFormBootstrapView} />;
        case 'LOJACK_MASTER_QUERY':
            if (!lojackFormBootstrapView) {
                return <></>;
            }
            return <DexLojackForm formBootstrapView={lojackFormBootstrapView} />;
        case 'PERSON_MASTER_QUERY':
            if (!personFormBootstrapView) {
                return <></>;
            }
            return (
                <DexPersonForm
                    formBootstrapView={personFormBootstrapView}
                    dexFormEventPanelPrefillValues={dexFormEventPanelPrefillValues}
                />
            );
        case 'PERSON_PROBATION_QUERY':
            if (!personProbationFormBootstrapView) {
                return <></>;
            }
            return <DexPersonForm formBootstrapView={personProbationFormBootstrapView} />;
        case 'PERSON_SEX_OFFENDER_QUERY':
            if (!personSexOffenderFormBootstrapView) {
                return <></>;
            }
            return <DexPersonForm formBootstrapView={personSexOffenderFormBootstrapView} />;
        case 'PERSON_WARRANT_DETAIL_QUERY':
            if (!personWarrantDetailFormBootstrapView) {
                return <></>;
            }
            return <DexPersonForm formBootstrapView={personWarrantDetailFormBootstrapView} />;
        case 'IMAGE_QUERY':
            if (!imageFormBootstrapView) {
                return <></>;
            }
            return <DexImageForm formBootstrapView={imageFormBootstrapView} />;
        case 'CRIMINAL_HISTORY_INDEX_QUERY':
            if (!criminalHistoryIndexFormBootstrapView) {
                return <></>;
            }
            return <DexPersonForm formBootstrapView={criminalHistoryIndexFormBootstrapView} />;
        case 'CRIMINAL_HISTORY_RECORD_REQUEST_QUERY':
            if (!criminalHistoryRecordRequestFormBootstrapView) {
                return <></>;
            }
            return (
                <DexPersonForm formBootstrapView={criminalHistoryRecordRequestFormBootstrapView} />
            );
        case 'CRIMINAL_HISTORY_IDENTITY_QUERY':
            if (!criminalHistoryIdentityQueryFormBootstrapView) {
                return <></>;
            }
            return (
                <DexPersonForm formBootstrapView={criminalHistoryIdentityQueryFormBootstrapView} />
            );
        case 'CRIMINAL_HISTORY_FULL_RECORD_QUERY':
            if (!criminalHistoryFullRecordFormBootstrapView) {
                return <></>;
            }
            return <DexPersonForm formBootstrapView={criminalHistoryFullRecordFormBootstrapView} />;
        case 'CRIMS_MASTER_QUERY':
            if (!crimsFormBootstrapView) {
                return <></>;
            }
            return <DexPersonForm formBootstrapView={crimsFormBootstrapView} />;
        case 'VEHICLE_MASTER_QUERY':
            if (!vehicleFormBootstrapView) {
                return <></>;
            }
            return (
                <DexVehicleForm
                    formBootstrapView={vehicleFormBootstrapView}
                    dexFormEventPanelPrefillValues={dexFormEventPanelPrefillValues}
                />
            );
        case 'VEHICLE_REGISTRATION_BY_PLATE_QUERY':
            if (!vehicleRegistrationByPlateFormBootstrapView) {
                return <></>;
            }
            return (
                <DexVehicleForm formBootstrapView={vehicleRegistrationByPlateFormBootstrapView} />
            );
        case 'VEHICLE_REGISTRATION_BY_VIN_QUERY':
            if (!vehicleRegistrationByVinFormBootstrapView) {
                return <></>;
            }
            return <DexVehicleForm formBootstrapView={vehicleRegistrationByVinFormBootstrapView} />;
        case 'VEHICLE_REGISTRATION_BY_NAME_QUERY':
            if (!vehicleRegistrationByNameFormBootstrapView) {
                return <></>;
            }
            return (
                <DexVehicleForm formBootstrapView={vehicleRegistrationByNameFormBootstrapView} />
            );
        case 'VEHICLE_REGISTRATION_BY_OTHER':
            if (!vehicleRegistrationByOtherFormBootstrapView) {
                return <></>;
            }
            return (
                <DexVehicleForm formBootstrapView={vehicleRegistrationByOtherFormBootstrapView} />
            );
        case 'VEHICLE_RECENT_QUERY_FILES':
            if (!vehicleRegistrationByRecentQueryFilesFormBoostrapView) {
                return <></>;
            }
            return (
                <DexVehicleForm
                    formBootstrapView={vehicleRegistrationByRecentQueryFilesFormBoostrapView}
                />
            );
        case 'VEHICLE_BY_NAME_QUERY':
            if (!vehicleByNameFormBootstrapView) {
                return <></>;
            }
            return <DexVehicleForm formBootstrapView={vehicleByNameFormBootstrapView} />;
        case 'VEHICLE_STOLEN_QUERY':
            if (!vehicleStolenFormBootstrapView) {
                return <></>;
            }
            return <DexVehicleForm formBootstrapView={vehicleStolenFormBootstrapView} />;
        case 'CANADIAN_WANTED_PERSON_QUERY':
            if (!canadianWantedPersonFormBootstrapView) {
                return <></>;
            }
            return <DexPersonForm formBootstrapView={canadianWantedPersonFormBootstrapView} />;
        case 'CANADIAN_DRIVER_LICENSE_QUERY':
            if (!canadianDriverLicenseFormBootstrapView) {
                return <></>;
            }
            return <DexPersonForm formBootstrapView={canadianDriverLicenseFormBootstrapView} />;
        case 'CANADIAN_VEHICLE_REGISTRATION_QUERY':
            if (!canadianVehicleRegistrationFormBootstrapView) {
                return <></>;
            }
            return (
                <DexVehicleForm formBootstrapView={canadianVehicleRegistrationFormBootstrapView} />
            );
        default:
            throw new Error(`DEx form ${dexForm} not implemented`);
    }
}

function getDexFormView(
    dexFormsResponse: DexFormsResponse,
    dexForm: DexDispatcherFormEnumType
): DexFormView | undefined {
    switch (dexForm) {
        case 'ARTICLE_MASTER_QUERY':
            return dexFormsResponse.articleFormBootstrapView?.dexFormView;
        case 'BOAT_MASTER_QUERY':
            return dexFormsResponse.boatFormBootstrapView?.dexFormView;
        case 'FIREARM_MASTER_QUERY':
            return dexFormsResponse.firearmFormBootstrapView?.dexFormView;
        case 'FIREARM_CONCEALED_WEAPONS_QUERY':
            return dexFormsResponse.firearmConcealedWeaponsFormBootstrapView?.dexFormView;
        case 'FIREARM_OWNERS_ID_QUERY':
            return dexFormsResponse.firearmsOwnersIdFormBootstrapView?.dexFormView;
        case 'LOJACK_MASTER_QUERY':
            return dexFormsResponse.lojackFormBootstrapView?.dexFormView;
        case 'PERSON_MASTER_QUERY':
            return dexFormsResponse.personFormBootstrapView?.dexFormView;
        case 'PERSON_PROBATION_QUERY':
            return dexFormsResponse.personProbationFormBootstrapView?.dexFormView;
        case 'PERSON_SEX_OFFENDER_QUERY':
            return dexFormsResponse.personSexOffenderFormBootstrapView?.dexFormView;
        case 'IMAGE_QUERY':
            return dexFormsResponse.imageFormBootstrapView?.dexFormView;
        case 'CRIMINAL_HISTORY_INDEX_QUERY':
            return dexFormsResponse.criminalHistoryIndexFormBootstrapView?.dexFormView;
        case 'CRIMINAL_HISTORY_RECORD_REQUEST_QUERY':
            return dexFormsResponse.criminalHistoryRecordRequestFormBootstrapView?.dexFormView;
        case 'CRIMINAL_HISTORY_IDENTITY_QUERY':
            return dexFormsResponse.criminalHistoryIdentityQueryFormBootstrapView?.dexFormView;
        case 'CRIMINAL_HISTORY_FULL_RECORD_QUERY':
            return dexFormsResponse.criminalHistoryFullRecordFormBootstrapView?.dexFormView;
        case 'PERSON_WARRANT_DETAIL_QUERY':
            return dexFormsResponse.personWarrantDetailFormBootstrapView?.dexFormView;
        case 'VEHICLE_MASTER_QUERY':
            return dexFormsResponse.vehicleFormBootstrapView?.dexFormView;
        case 'VEHICLE_REGISTRATION_BY_PLATE_QUERY':
            return dexFormsResponse.vehicleRegistrationByPlateFormBootstrapView?.dexFormView;
        case 'VEHICLE_REGISTRATION_BY_VIN_QUERY':
            return dexFormsResponse.vehicleRegistrationByVinFormBootstrapView?.dexFormView;
        case 'VEHICLE_REGISTRATION_BY_NAME_QUERY':
            return dexFormsResponse.vehicleRegistrationByNameFormBootstrapView?.dexFormView;
        case 'VEHICLE_REGISTRATION_BY_OTHER':
            return dexFormsResponse.vehicleRegistrationByOtherFormBootstrapView?.dexFormView;
        case 'VEHICLE_RECENT_QUERY_FILES':
            return dexFormsResponse.vehicleRegistrationByRecentQueryFilesFormBoostrapView
                ?.dexFormView;
        case 'VEHICLE_BY_NAME_QUERY':
            return dexFormsResponse.vehicleByNameFormBootstrapView?.dexFormView;
        case 'VEHICLE_STOLEN_QUERY':
            return dexFormsResponse.vehicleStolenFormBootstrapView?.dexFormView;
        case 'CRIMS_MASTER_QUERY':
            return dexFormsResponse.crimsFormBootstrapView?.dexFormView;
        case 'CANADIAN_WANTED_PERSON_QUERY':
            return dexFormsResponse.canadianWantedPersonFormBootstrapView?.dexFormView;
        case 'CANADIAN_DRIVER_LICENSE_QUERY':
            return dexFormsResponse.canadianDriverLicenseFormBootstrapView?.dexFormView;
        case 'CANADIAN_VEHICLE_REGISTRATION_QUERY':
            return dexFormsResponse.canadianVehicleRegistrationFormBootstrapView?.dexFormView;
        default:
            throw new Error(`DEx form ${dexForm} not implemented`);
    }
}

function DexFormPanelTitle({
    dexFormsResponse,
    dexForm,
}: {
    dexFormsResponse: DexFormsResponse;
    dexForm: DexDispatcherFormEnumType;
}): React.ReactElement {
    const dexFormView = getDexFormView(dexFormsResponse, dexForm);
    if (!dexFormView) {
        return <></>;
    }
    return <PanelTitle>{dexFormView.title}</PanelTitle>;
}

const OriAliasDexForm = observer(function OriAliasDexForm({
    panel,
}: {
    panel: WorkspacePanel;
}): React.ReactElement {
    const { data } = useDexFormsQuery();
    const dexFormsResponse = useDexFormView({ dexFormsResponse: data });
    const { dexNextEnabled } = useEnabledFeatures();

    if (dexNextEnabled) {
        return <DexNextFormPanel panel={panel} />;
    }

    if (!panel.dexForm) {
        throw new Error('panel does not have dexForm');
    }
    if (!dexFormsResponse) {
        return <></>;
    }
    return (
        <Panel
            panel={panel}
            header={
                <DexFormPanelTitle dexFormsResponse={dexFormsResponse} dexForm={panel.dexForm} />
            }
            body={
                <DexFormPanelBody
                    dexFormsResponse={dexFormsResponse}
                    dexForm={panel.dexForm}
                    dexFormEventPanelPrefillValues={panel.getPanelState('dexFormPrefill')}
                />
            }
        />
    );
});

export const DexFormPanel = observer(function DexFormPanel({
    panel,
}: {
    panel: WorkspacePanel;
}): React.ReactElement {
    return (
        <SelectedOriAliasProvider>
            <OriAliasDexForm panel={panel} />
        </SelectedOriAliasProvider>
    );
});
